export enum GiftLayoutEnum {
    SINGLE = 'single',
    DOUBLE = 'double',
}
